"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GLOBAL_TAXONOMY_PRODUCT_TREE_TITLE = void 0;
exports.GLOBAL_TAXONOMY_PRODUCT_TREE_TITLE = 'Global';
